export const getBranchSelectionData = (branchNameEnergy, branchNameGas) => {
  const partsEnergy = branchNameEnergy.match(/[A-Z][a-z]*/g) || [];
  const partsGas = branchNameGas.match(/[A-Z][a-z]*/g) || [];

  return {
    isEnergyActive: partsEnergy.length > 0,
    isGasActive: partsGas.length > 0,
  };
};
